import { BaseSelectorOption } from "@/types";
import { AppContext } from "../../common/AppContext";
import { LocationSelectorList } from "../../data/filters/LocationSelectorList";
import { LocationFilter, LocationFilterProps } from "./LocationFilter";

interface LocationSelectorOption extends BaseSelectorOption {
  locationId: string;
}

export class LocationSelector<
  T extends LocationSelectorOption = LocationSelectorOption
> extends LocationFilter<T> {
  static contextType = AppContext;

  static defaultProps = {
    ...LocationFilter.defaultProps,
    label: "Location",
    matchFrom: "any",
    listType: "Locations"
  };

  constructor(props: LocationFilterProps<T>) {
    super(props);

    this.dataList = LocationSelectorList;
  }

  getItemId(item: T) {
    console.log("item", item);

    return item.locationId;
  }

  getItemLabel(item: T) {
    const { getItemLabel } = this.props;

    if (getItemLabel) return getItemLabel(item);
    return item as unknown as string;
  }

  getList(dataList: LocationSelectorList) {
    return dataList.locations;
  }
}
